import { render, staticRenderFns } from "./facWei.vue?vue&type=template&id=2735e74c&scoped=true&"
import script from "./facWei.vue?vue&type=script&lang=js&"
export * from "./facWei.vue?vue&type=script&lang=js&"
import style0 from "./facWei.vue?vue&type=style&index=0&id=2735e74c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2735e74c",
  null
  
)

export default component.exports